<template>
  <svg
    width="20"
    height="12"
    viewBox="0 0 12 8"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8666 4.00008C11.8666 4.36827 11.5681 4.66675 11.1999 4.66675L0.79991 4.66675C0.431721 4.66675 0.133244 4.36827 0.133244 4.00008C0.133244 3.63189 0.431721 3.33342 0.79991 3.33342L11.1999 3.33342C11.5681 3.33342 11.8666 3.63189 11.8666 4.00008Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.52851 7.67144C7.26816 7.41109 7.26816 6.98898 7.52851 6.72863L10.2571 4.00003L7.52851 1.27144C7.26816 1.01109 7.26816 0.58898 7.52851 0.32863C7.78886 0.0682797 8.21096 0.0682797 8.47131 0.32863L11.6713 3.52863C11.7963 3.65365 11.8666 3.82322 11.8666 4.00003C11.8666 4.17684 11.7963 4.34641 11.6713 4.47144L8.47131 7.67144C8.21096 7.93179 7.78886 7.93179 7.52851 7.67144Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
